import { Card } from "@heroui/react";
import { getBoxTokenFromServer } from "@onesolution/serverFn/getBoxToken";
import { useEffect } from "react";
import { useBoolean } from "usehooks-ts";

declare global {
	interface Window {
		// biome-ignore lint/suspicious/noExplicitAny: <need to find ts definition>
		Box: any;
	}
}

export default function BoxContentExplorer({
	rootFolderId,
	...props
}: { rootFolderId: string; className?: string }) {
	const tokenQuery = getBoxTokenFromServer.useQuery();
	const { value: isSet, setTrue } = useBoolean(false);

	useEffect(() => {
		if (!window.Box || !tokenQuery.data || !rootFolderId || isSet) {
			return;
		}

		const explorer = new window.Box.ContentExplorer();
		explorer.show(rootFolderId, tokenQuery.data, {
			container: ".boxcontainer",
			responseInterceptor: (response: {
				data: { entries: Array<{ type: string; extension: null | string }> };
			}) => {
				const entries = response?.data?.entries;
				if (Array.isArray(entries)) {
					for (const item of entries) {
						if (item.type === "folder" && item.extension === null) {
							item.extension = "";
						}
					}
				}
				return response;
			},
			logoUrl: "box",
			sortBy: "name",
			sortDirection: "ASC",
			canDownload: true,
			multiSelect: true,
			metadataViewProps: {
				isSelectionEnabled: true,
			},
			contentPreviewProps: {
				contentSidebarProps: {
					detailsSidebarProps: {
						hasNotices: true,
						hasProperties: true,
						hasAccessStats: true,
						hasVersions: true,
					},
					hasActivityFeed: true,
					hasSkills: true,
					hasMetadata: true,
				},
			},
		});
		setTrue();
	}, [rootFolderId, tokenQuery.data, isSet, setTrue]);

	return (
		<Card {...props}>
			<div
				className="boxcontainer"
				style={{
					width: "100%",
					height: "100%",
				}}
			/>
		</Card>
	);
}
